// extracted by mini-css-extract-plugin
module.exports = {"AlertBox":"AlertBox_AlertBox__3wLkP","alertMsg":"AlertBox_alertMsg__KA4mr"};